<template>
  <div>
    <div class="d-flex">
      <v-btn color="channelbtn" class="mr-2" dark depressed @click="addLink">
        Add
      </v-btn>
      <v-btn
        color="warning"
        class="mr-2"
        depressed
        @click="editLink"
        :disabled="btnDisabled"
      >
        Edit
      </v-btn>
      <v-btn
        color="error"
        class="mr-2"
        depressed
        @click.stop="deleteConfirmDialog = true"
        :disabled="btnDisabled"
      >
        Remove
      </v-btn>
    </div>
    <div class="mt-4">
      <v-card>
        <v-card-title>
          Collections
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          v-if="loaded"
          :headers="headers"
          :items="collections"
          :search="search"
          :options="pageOptions"
          class="border"
          show-select
          :hide-default-footer="false"
          :single-select="singleSelect"
          v-model="selectedCollection"
          @update:options="savePageOptions"
        >
          <template v-slot:[`item.who`]="{ item }">
            <div>
              <span>{{ item.who }}</span>
            </div>
          </template>
          <template v-slot:[`item.when`]="{ item }">
            <div>
              <span>{{ item.when }}</span>
            </div>
          </template>
          <template v-slot:[`item.where`]="{ item }">
            <div>
              <span>{{ item.where }}</span>
            </div>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <div>
              <span>{{ $moment(item.created_at).format("YYYY-MM-DD") }}</span>
            </div>
          </template>

          <template v-slot:[`item.link`]="{ item }">
            <div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-3"
                    small
                    icon
                    @click="doLink('view', item.id)"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon color="blue-grey" dark>
                      mdi-monitor-dashboard
                    </v-icon></v-btn
                  >
                </template>
                <span class="caption">Viewer</span>
              </v-tooltip>
              <v-tooltip top v-if="item.mode_api != false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-3"
                    small
                    icon
                    @click="openApiDialog(item.id)"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon color="blue-grey" dark>
                      mdi-api
                    </v-icon></v-btn
                  >
                </template>
                <span class="caption">API</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    @click="openShareDialog(item.id)"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon color="blue-grey" dark>
                      mdi-export-variant
                    </v-icon></v-btn
                  >
                </template>
                <span class="caption">Share</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <!-- api 모달 창 -->
    <v-dialog v-model="apiDialog" width="720px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">API</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="closeApiDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <div class="d-flex pb-2">
            <div>
              Collection Id
            </div>
            <div v-show="collectionIdCopied" class="red--text ml-auto mr-9">
              Copied!
            </div>
          </div>
          <v-text-field
            v-model="collection_id"
            readonly
            outlined
            name="collectionTextField"
            ref="collectionTextField"
            append-outer-icon="mdi-content-copy"
            @click:append-outer="copyCollectionId"
          ></v-text-field>
          <div>
            Use the code below in your html page
          </div>
          <VueCodeHighlight language="html" :key="vueCodeHighlight_key">
            <pre id="api-code">


&lt;!-- Place it at the top of the DOM. Videos will be displayed in this DIV --&gt;
&lt;div id="onseminar-overlay">&lt;/div&gt;

&lt;!-- Place it where you want it. List of videos works on this DIV --&gt;
&lt;div id="onseminar-container">&lt;/div&gt;

&lt;script src="https://onseminar.com/api2/onseminar.min.js">&lt;/script&gt;               
&lt;script&gt;
    onseminar.init({
      id:'{{ collection_id }}', // collection id
      /* Optional 
      header: true,  // show header
      category: true, // show category
      item: {
        date: true,   // show date of item
        view: true,   // show view count of item
        author: true, // show author of item
      },
      beforePlayFunc: UserDefinedFunction 
      //  Hook will execute when click a item
      //  if return value of hook is true, video will be played
      */
    })
&lt;/script&gt;


</pre
            >
          </VueCodeHighlight>
          <div class="ma-0 caption">Allowed hosts</div>
          <div class="domain-wrap">
            <div class="caption" v-if="api_domains.length > 0">
              {{ api_domains.toString() }}
            </div>
            <div class="caption" v-if="api_domains.length == 0">
              No hosts are allowed. Contact service manager
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- qrcode share 모달 창 -->
    <v-dialog v-model="shareDialog" width="600px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text">Share</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="closeShareDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <div class="d-flex pb-2">
            <div>
              Collection Url
            </div>
            <div v-show="collectionCopied" class="red--text ml-auto mr-9">
              Copied!
            </div>
          </div>
          <v-text-field
            v-model="collection_url"
            readonly
            outlined
            name="collectionTextField"
            ref="collectionTextField"
            append-outer-icon="mdi-content-copy"
            @click:append-outer="copyCollectionUrl"
          ></v-text-field>
          <div>
            <div class="d-flex pb-0">
              <div>
                QR Code
              </div>
              <div v-show="collectionQRCopied" class="red--text ml-auto mr-9">
                Copied!
              </div>
            </div>
            <v-row>
              <v-col cols="4" class="pt-0">
                <v-row class="pa-0">
                  <v-col cols="12" class="pa-0">
                    <v-img :src="collection_qr_url"></v-img>
                  </v-col>
                  <v-col cols="12" class="pt-0 pr-2 pl-2">
                    <v-btn
                      block
                      small
                      color="channel"
                      dark
                      @click="downloadQRcode"
                      ><v-icon small class="pr-3">mdi-download</v-icon
                      >download</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="8" class="pt-2">
                <v-textarea
                  v-model="collection_qr_url"
                  readonly
                  outlined
                  aria-multiline=""
                  dense
                  name="collectionQRTextField"
                  ref="collectionQRTextField"
                  append-outer-icon="mdi-content-copy"
                  @click:append-outer="copyCollectionQRcodeUrl"
                ></v-textarea>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 컬렉션삭제확인 모달창 -->
    <v-dialog v-model="deleteConfirmDialog" width="500">
      <v-card>
        <div color="error" class="d-flex pa-2 align-center error">
          <v-card-title class="headline white--text">Delete</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="deleteConfirmDialog = false">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <v-icon small>mdi-alert-circle-outline</v-icon> Are you sure you want
          to delete the Collection?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="mr-2 text-capitalize"
            @click="deleteCollection(selectedCollection[0].id)"
          >
            Delete
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="deleteConfirmDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { listCollections } from "../graphql/Query";
import { createCollection, deleteCollection } from "../graphql/Mutation";
import { component as VueCodeHighlight } from "vue-code-highlight";
import "../../node_modules/vue-code-highlight/themes/prism-coy.css";

export default {
  components: {
    VueCodeHighlight
  },
  data: () => ({
    loaded: false,
    pageOptions: {},
    collections: [],
    search: "",
    title: "",
    apiDialog: false,
    preCode: "",
    shareDialog: false,
    singleSelect: true,
    deleteConfirmDialog: false,
    selectedCollection: [],
    collection_id: "",
    collectionIdCopied: false,
    collection_url: "",
    collection_qr_url: "",
    collectionCopied: false,
    collectionQRCopied: false,
    headers: [
      { text: "Title", value: "title", sortable: true },
      { text: "Created at", value: "created_at", sortable: true },
      { text: "Privacy_Who", value: "who", sortable: false },
      { text: "Privacy_When", value: "when", sortable: false },
      { text: "Privacy_Where", value: "where", sortable: false },
      {
        text: "Link",
        value: "link",
        sortable: false
      }
    ],
    api_domains: [],
    vueCodeHighlight_key: 1
  }),
  computed: {
    btnDisabled: function() {
      return this.selectedCollection.length <= 0;
    }
  },

  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      const from = this.$route.query.from;
      if (from == "edit") {
        this.pageOptions = this.$store.state.pageOptions;
        console.log("pageOptions", this.pageOptions);
      }
      this.collections = [];
      await this.getListCollections(); // content.categories
      this.loaded = true;
    },
    async getListCollections() {
      // 채널 전체 컬렉션가져오기
      const channel_id = this.$store.state.channelId;

      const { data } = await this.$apollo.query({
        query: listCollections,
        variables: {
          channel_id: channel_id
        },
        fetchPolicy: "no-cache"
      });

      this.collections = data.listCollections.items;
      this.collections.sort((a, b) => (a.created_at < b.created_at ? 1 : -1));

      console.log("collections", this.collections);
    },
    async addLink() {
      const input = {
        title: "Untitled",
        channel_id: this.$store.state.channelId,
        header: true,
        who: "anyone",
        when: "permanent",
        where: "anywhere",
        mode_collection: true,
        mode_api: false
      };
      // 컬렉션 기본정보 DB등록
      try {
        const { data } = await this.$apollo.mutate({
          mutation: createCollection,
          variables: { input },
          fetchPolicy: "no-cache"
        });
        if (data.createCollection) {
          this.collections.unshift(data.createCollection);
          console.log("collection:", data.createCollection);
        }
      } catch (e) {
        console.log("[CollectionList/createCollection]", e);
      }
    },
    copyCollectionId() {
      const copyText = this.$refs.collectionTextField.$el.querySelector(
        "input"
      );
      copyText.select();
      document.execCommand("copy");
      this.collectionIdCopied = true;
      setTimeout(() => {
        this.collectionIdCopied = false;
      }, 2000);
    },
    copyCollectionUrl() {
      const copyText = this.$refs.collectionTextField.$el.querySelector(
        "input"
      );
      copyText.select();
      document.execCommand("copy");
      this.collectionCopied = true;
      setTimeout(() => {
        this.collectionCopied = false;
      }, 2000);
    },
    copyCollectionQRcodeUrl() {
      const copyText = this.$refs.collectionQRTextField.$el.querySelector(
        "textarea"
      );
      copyText.select();
      document.execCommand("copy");
      this.collectionQRCopied = true;
      setTimeout(() => {
        this.collectionQRCopied = false;
      }, 2000);
    },
    downloadQRcode() {
      this.$axios
        .get(this.collection_qr_url, { responseType: "blob" })
        .then(response => {
          const blob = new Blob([response.data], { type: "image/png" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "qrcode";
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    doLink(mode, link) {
      console.log(mode, link);
      if (mode == "view") {
        const url = process.env.VUE_APP_BASE_URL + "/collection/" + link;
        window.open(url);
        // console.log({ url });
      }
      if (mode == "api") {
        this.apiDialog = true;
      }
    },
    editLink() {
      if (this.selectedCollection.length == 0) return null;
      this.$router.push({
        name: "Collection",
        query: { collection_id: this.selectedCollection[0].id }
      });
    },
    openApiDialog(id) {
      console.log({ id });
      this.apiDialog = true;
      this.collection_id = id;
      this.vueCodeHighlight_key = this.vueCodeHighlight_key + 1;
      const collection = this.collections.find(item => item.id == id);
      console.log(collection, this.collection_id);
      const licenses = collection.channel.licenses;
      if (licenses && Array.isArray(licenses)) {
        licenses.forEach(item => {
          if (item.mode == "api") {
            this.api_domains.push(item.domain);
          }
        });
      }
    },
    openShareDialog(id) {
      this.shareDialog = true;
      this.collection_url = process.env.VUE_APP_BASE_URL + "/collection/" + id;
      this.collection_qr_url =
        process.env.VUE_APP_BASE_URL +
        "/pub/channel/" +
        this.$store.state.channelId +
        "/collection/" +
        id +
        "/qrcode.png";
      console.log(id);
    },
    closeDeleteConfirmDialog() {
      this.deleteConfirmDialog = false;
    },
    closeApiDialog() {
      this.apiDialog = false;
      this.collection_id = "";
      this.api_domains = [];
    },
    closeShareDialog() {
      this.shareDialog = false;
    },
    async deleteCollection(id) {
      const input = {
        channel_id: this.$store.state.channelId,
        id: id
      };

      try {
        const { data } = await this.$apollo.mutate({
          mutation: deleteCollection,
          variables: { input },
          fetchPolicy: "no-cache"
        });

        const cid = data.deleteCollection.id;
        const ctitle = data.deleteCollection.title;

        const idx = this.collections.findIndex(x => x.id == cid);
        console.log({ cid, idx });
        this.collections.splice(idx, 1);
        this.$store.dispatch("logger", {
          menu: "Collections",
          level: "success",
          message: `Delete collection [${ctitle}]`
        });
      } catch (e) {
        console.log("[CollectionList/deleteCollection", e);
      }
      this.closeDeleteConfirmDialog();
    },
    savePageOptions(evt) {
      this.$store.commit("SET_PAGE_OPTIONS", evt);
      console.log("pageOptions", this.$store.state.pageOptions);
    }
  }
};
</script>
<style scoped>
.domain-wrap {
  width: 100%;
  padding: 5px;
  margin-top: 2px;
  border-radius: 6px;
  border: 1px solid rgb(206, 206, 206);
}
</style>
